<template>
  <v-container fluid >
    <!-- Hero Banner -->
    <v-card flat class="white--text" color="primary" height="180">
      <v-row align="center" justify="center" class="fill-height text-center">
        <v-col cols="12">
          <h1 class="font-weight-bold mb-2">Integration</h1>
          <h4 class="font-weight-light">
            Discover tools & integrations to grow your business
          </h4>
        </v-col>
      </v-row>
    </v-card>

    <!-- Apps Grid -->
    <v-container class="mt-6">
      <v-row >
        <v-col
          v-for="app in apps"
          :key="app.id"
          cols="12"
          sm="6"
          md="4"
          lg="3"
          class="d-flex"
        >
          <v-card
            :to="`/marketplace/app/${app.id}`"
            class="flex-grow-1 d-flex flex-column hover-card"
            elevation="2"
          >
            <!-- App Image -->
            <v-img
              v-if="app.imageURL"
              :src="app.imageURL"
              height="150"
              class="grey lighten-4"
              contain
            ></v-img>
            <v-responsive v-else height="150" class="grey lighten-3 d-flex align-center justify-center">
              <v-icon size="64" color="grey darken-2">mdi-apps</v-icon>
            </v-responsive>

            <!-- App Info -->
            <v-card-text class="flex-grow-1 d-flex flex-column justify-space-between">
              <div>
                <h3 class="subtitle-1 font-weight-medium text-truncate">
                  {{ app.name }}
                </h3>
                <p class="text-body-2 grey--text text--darken-1 mt-1">
                  {{ app.description || 'No description available.' }}
                </p>
              </div>

              <!-- Price & Installed -->
              <div class="d-flex align-center justify-space-between mt-3">
                <v-chip
                  small
                  color="green lighten-5"
                  text-color="green darken-2"
                >
                  {{ app.price > 0 ? $options.filters.currency(app.price) : "Free" }}
                </v-chip>

                <v-chip
                  v-if="locationModules[app.pubSubHook.toLowerCase()]"
                  small
                  color="blue lighten-5"
                  text-color="blue darken-2"
                >
                  <v-icon left small>mdi-check-circle</v-icon>
                  {{
                    locationModules[app.pubSubHook.toLowerCase()].LocationIntegrations.length
                  }}
                  Installed
                </v-chip>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Coming soon -->
      <v-row>
        <v-col cols="12" class="text-center mt-8">
          <h4 class="font-weight-light grey--text">
            🚀 Many more integrations coming soon!
          </h4>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import marketplaceService from "../service.js";

export default {
  name: "marketplace-home",
  async created() {
    this.isLoading = true;
    await this.loadApps();
    this.isLoading = false;
  },
  data() {
    return {
      count: 0,
      apps: [],
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters("integration", ["locationModules", "modules"]),
  },
  methods: {
  loadApps() {
    const currentBrand = this.$store.getters["brand/currentBrand"];

    return marketplaceService
      .getAll({ active: true, audience: "terminal" })
      .then((response) => {
        // raw list from backend
        const apps = response.data || [];

        // filter by brand
        this.apps = apps.filter(app => {
          return Array.isArray(app.brands) && app.brands.includes(currentBrand);
        });

        this.count = this.apps.length;
      });
  },
},
};
</script>

<style scoped>
.hover-card {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
}
.hover-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.15);
}
</style>